import type { Query } from '@tanstack/react-query';
import { useGetThesisReplyEligibilitySpec } from '../../../../generated/specs/theses.spec.gen.js';
import { hashDiagnosticEntity } from '../../../../tx-engine/diagnostics/lifecycle.js';
import type { TradeMutationDeps } from '../types.js';

export function reconcileThesisReplyEligibility(
  deps: Pick<TradeMutationDeps, 'queryClient' | 'logger'>,
  marketAddress: string,
): void {
  void deps.queryClient
    .invalidateQueries({
      queryKey: ['theses', 'detail', { marketPubkey: marketAddress }],
      predicate: (query: Query): boolean =>
        query.meta?.specName === useGetThesisReplyEligibilitySpec.specName,
    })
    .catch((error: Error) => {
      deps.logger.warn('trade.thesis_reply_eligibility_reconciliation_failed', {
        marketHash: hashDiagnosticEntity(marketAddress),
        errorClass: error.name,
      });
    });
}
